import { supabase } from '@/lib/supabase'

export async function fetchVisionModeratorEnabled(): Promise<boolean> {
  try {
    const { data, error } = await supabase.rpc('user_vision_moderator_enabled' as any)
    if (error) {
      // eslint-disable-next-line no-console
      console.error('user_vision_moderator_enabled error', error)
      return false
    }
    return Boolean(data)
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('user_vision_moderator_enabled error', e)
    return false
  }
}
